const spacing = {
  paddingSmall: "8px",
  paddingMedium: "16px",
  paddingLarge: "32px",
  paddingXLarge: "64px",

  marginSmall: "8px",
  marginMedium: "16px",
  marginLarge: "32px",
  marginXLarge: "64px",

  gapSmall: "4px",
  gapMedium: "16px",
  gapLarge: "32px",
  gapXLarge: "64px",

  borderRadiusSmall: "4px",
  borderRadiusMedium: "8px",
  borderRadiusLarge: "16px",
  borderRadiusXLarge: "32px",
};

export default spacing;
